import gql from 'graphql-tag';
import React from 'react';
import { View } from 'react-native';
import { Text } from '../../components';
import isCommDeviceEligibleForMachineSetup from '../../../common/utils/commDevice/isCommDeviceEligibleForMachineSetup';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import SearchDropdownSelector from './SearchDropdownSelector';

export const GET_COMM_DEVICES = gql`
	query(
		$page: Int!,
		$perPage: Int!,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: CommDevicePageFilter
	) {
		getCommDevices(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				deviceId
				secondaryId
				pointOfSale {
					id
					assetId
					place {
						id
						name
					}
					location {
						id
						name
					}
				}
			}
			count
		}
	}
`;


const getDeviceLabel = item => (item.secondaryId ? `${item.deviceId} / ${item.secondaryId}` : item.deviceId);

const CommDeviceSelector = ({
	disabledItemPredicate,
	query,
	renderItem,
	renderLabel,
	selectablePointOfSale,
	showAllocationContext = false,
	...props
}) => {
	const styles = useThemedStyles(createStyles);

	const isUnavailable = item => Boolean(selectablePointOfSale && !isCommDeviceEligibleForMachineSetup(item, selectablePointOfSale));

	const renderAllocationLabel = item => {
		if (!item.pointOfSale) {
			return 'Unassigned';
		}

		const allocationDetails = [
			item.pointOfSale.assetId,
			item.pointOfSale.location?.name,
			item.pointOfSale.place?.name,
		].filter(Boolean);

		return `Assigned to ${allocationDetails.join(' · ') || 'another machine'}${isUnavailable(item) ? ' · Unavailable' : ''}`;
	};

	const renderCommDeviceItem = item => (
		showAllocationContext ? (
			<View style={isUnavailable(item) ? styles.unavailableItem : null}>
				<Text>{getDeviceLabel(item)}</Text>
				<Text style={styles.allocationLabel}>{renderAllocationLabel(item)}</Text>
			</View>
		) : (
			<Text>{getDeviceLabel(item)}</Text>
		)
	);

	const resolvedDisabledItemPredicate = disabledItemPredicate || selectablePointOfSale
		? item => Boolean(disabledItemPredicate?.(item) || isUnavailable(item))
		: undefined;

	return (
		<SearchDropdownSelector
			query={query || GET_COMM_DEVICES}
			renderItem={renderItem || renderCommDeviceItem}
			renderLabel={renderLabel || (item => <Text>{getDeviceLabel(item)}</Text>)}
			disabledItemPredicate={resolvedDisabledItemPredicate}
			placeholder="Select comm device"
			{...props}
		/>
	);
};

const createStyles = theme => ({
	allocationLabel: {
		color: theme.text2,
		fontSize: 12,
		marginTop: 2,
	},
	unavailableItem: {
		opacity: 0.55,
	},
});

export default CommDeviceSelector;
